import { createAction } from 'redux-actions';

export const SHOW_TRIAL_DAYS = 'SHOW_TRIAL_DAYS';
export const HIDE_TRIAL_DAYS = 'HIDE_TRIAL_DAYS';
export const SET_DAYS_LEFT = 'SET_DAYS_LEFT';
export const RENEW_SESSION = 'RENEW_SESSION';
export const EXPIRE_TRIAL = 'EXPIRE_TRIAL';

export const showTrialDays = createAction(SHOW_TRIAL_DAYS);
export const hideTrialDays = createAction(HIDE_TRIAL_DAYS);
export const setDaysLeft = createAction(SET_DAYS_LEFT);
export const renewSession = createAction(RENEW_SESSION);
export const expireTrial = createAction(EXPIRE_TRIAL);
